import { createElement, memo, useState } from '@max/max';
import View from '@hfe/max-view';
import LinearGradient from '@hfe/max-linear-gradient';
import ActivityCountdown from '../activity-countdown';
import SubscribeButton, { SubscribeStatus } from '../subscribe-button';
import './index.scss';
import { BID_MAP, BID_TYPE } from '../../constants';
import Sensor from '@max/mbc-sensor';
const ActivitySubscribeSection = memo((props) => {
    const { activityId, drawModuleInfo, subscribeConfig, onCountdownEnd, onSubscribeStatusChange: updateSubscribeStatus, onSubscribed, lxReport } = props;
    const [subscribeStatus, setSubscribeStatus] = useState(SubscribeStatus.SUBSCRIBED);
    const isSubscribed = subscribeStatus === SubscribeStatus.SUBSCRIBED;
    const backgroundColor = isSubscribed ? ['#FFDD0033', '#FFDD0033'] : ['#FF9233', '#FF5500'];
    const { inDrawTime, nextDrawTimeStart: appointmentTime } = drawModuleInfo || {};
    const onSubscribeStatusChange = (status) => {
        if (status !== subscribeStatus) {
            updateSubscribeStatus === null || updateSubscribeStatus === void 0 ? void 0 : updateSubscribeStatus(status);
        }
        setSubscribeStatus(status);
    };
    // 如果当前在抽奖时间内，不显示整个组件
    if (inDrawTime || !appointmentTime) {
        return null;
    }
    return <Sensor once onAppear={() => {
        lxReport(BID_MAP.MODULE_MV, BID_TYPE.MV);
    }}>
      <LinearGradient className="activity-subscribe-section-container" colors={backgroundColor} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }}>
        <View className="activity-subscribe-section-countdown">
          <ActivityCountdown appointmentTime={appointmentTime} onCountdownEnd={onCountdownEnd} fontColor={isSubscribed ? '#401502' : '#ffffff'}/>
        </View>

        <View className="activity-subscribe-section-divider" style={{
        backgroundColor: subscribeStatus === SubscribeStatus.SUBSCRIBED ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.6)'
    }}/>

        <View className="activity-subscribe-section-button">
          <SubscribeButton activityId={activityId} drawModuleInfo={drawModuleInfo} subscribeConfig={subscribeConfig} onSubscribeStatusChange={onSubscribeStatusChange} onSubscribed={onSubscribed} lxReport={lxReport} fontColor={isSubscribed ? '#401502' : '#ffffff'}/>
        </View>
      </LinearGradient>
    </Sensor>;
});
export default ActivitySubscribeSection;
